// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `button.maplibregl-popup-close-button {
    width: 30px;
    height: 30px;
    font-size: 30px !important;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 15px;
    color: #222222;
    border-radius: 15px;
    outline: none !important;
    background-color: rgba(255, 255, 255, 0.20);
    transition: all 0.3s;

    &:hover {
        font-size: 30px;
        background-color: rgba(255, 255, 255, 0.40);
    }
}

.maplibregl-popup {
    z-index: 3;
}

.maplibregl-popup-content {
    padding: 45px 20px 20px;
    font-family: "GTAmerica-Rg", "franklingothic-book", serif;
    font-size: 15px;
    background-color: white;
    color: #222222;
    min-width: 150px;
    text-align: center;
    border-radius: 4px;
    word-break: break-word;
    box-shadow: 0 10px 20px 0 rgba(0, 4, 8, 0.07);
}

.maplibregl-popup-anchor-bottom .maplibregl-popup-tip {
    border-color: transparent;
    border-top-color: #ffffff;
    box-shadow: 0 10px 20px 0 rgba(0, 4, 8, 0.07);
}

.maplibregl-popup-anchor-top .maplibregl-popup-tip {
    border-color: transparent;
    border-bottom-color: #ffffff;
    box-shadow: 0 10px 20px 0 rgba(0, 4, 8, 0.07);
}

.maplibregl-ctrl {
    display: none;
}

.maplibregl-layer {
    position: absolute;
    z-index: 2;
}

.maplibregl-map {

}

.maplibregl-h3 {
    padding: 10px 0 0;
    margin: 0;
    font-family: "GTAmerica-Bd", "franklingothic-book", serif;
    font-size: 17px;
    letter-spacing: -0.5px;
    font-weight: normal;
    line-height: 1.2;
}

.maplibregl-h4 {
    margin: 5px 0 -4px;
    font-family: "GTAmerica-Bd", "franklingothic-book", serif;
    font-size: 14px;
    line-height: 1.11;
    font-weight: normal;
    letter-spacing: -0.25px;
    color: #888888;
}

.maplibregl-h5 {
    font-family: "GTAmerica-Bd", "franklingothic-book", serif;
    font-size: 13px;
    line-height: 1.11;
    font-weight: normal;
    letter-spacing: -0.25px;
    color: #888888;
    margin: 12px 0 0 0;
}

.maplibregl-label, .maplibregl-layer-button {
    background-color: #a21236;
    border-radius: 4px;
    color: white;
    font-size: .8em;
    padding: 2px 10px;
    font-weight: bold;
    margin-right: 10px;
    margin-top: 10px;
    border: 0;
    line-height: 20px;
    transition: all 0.2s;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 220px;
}

.maplibregl-layer-button {
    cursor: pointer;
    max-width: 300px;
}

.maplibregl-layer h5 {
    text-transform: none;
}

.maplibregl-layer-button-content {
    display: flex;
    align-items: center;
}

.maplibregl-content {
    color: #888888;
    padding: 20px 0 15px;
}

.maplibregl-container {
    position: relative;
    border-radius: 4px;
    background-color: #ffffff;
}

.maplibregl-map-container {
    position: relative;
    height: 100%;
}

.maplibregl-map-fullscreen {

}


.maplibregl-toggle {
    position: absolute;
    bottom: 20px;
    left: 30px;
    background-color: #ffffff;
    z-index: 2;
    border-radius: 4px;
    padding: 10px 10px 0;
    cursor: pointer;
    overflow: hidden;
    box-shadow: 0 2px 5px 0 rgba(0, 4, 8, 0.07)
}

.maplibregl-layer-toggle {
    bottom: 20px;
}

.maplibregl-fullscreen-toggle {
    bottom: 50px;
}

.maplibregl-layer {
    margin: 10px;
    background-color: #ffffff;
    border-radius: 4px;
    padding: 0 10px 10px;
    box-shadow: 0 2px 5px 0 rgba(0, 4, 8, 0.07);
    position: absolute;
    bottom: 20px;
    left: 70px;
    transition: all 0.3s;
    max-width: calc(100vw - 140px);
}

.maplibregl-layer-button-disabled {
    background-color: #aaaaaa;
}

.maplibregl-layer-toggle svg, .maplibregl-fullscreen-toggle svg {
    color: #a31335;
    transition: all 0.2s;
}

.maplibregl-layer-toggle-disabled svg, .maplibregl-fullscreen-toggle-disabled svg {
    color: #aaaaaa;
}

.maplibregl-legend {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    background-color: rgba(255, 255, 255, 0.9);
    border-radius: 4px;
    z-index: 2;
    right: 20px;
    top: 20px;
    padding: 10px 10px 0;
    margin: 0;
}

.maplibregl-legend-item {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 10px;
}

.maplibregl-legend-item-style {
    margin-right: 10px;
}

.maplibregl-labels {
    text-align: center;
    display: flex;
    flex-wrap: wrap;
}

.maplibregl-links {
    margin-top: 0px;
    margin-bottom: 10px;
    display: flex;
    flex-wrap: inherit;
    flex-direction: column;
}

.maplibregl-link {
    color: #a01637;
    padding: .25rem;
    font-size: 13px;
    font-family: "GTAmerica-Bd", "franklingothic-book", serif;
    font-weight: bold;
    text-decoration: none;
    border-radius: 4px;
    transition: all 0.3s;
    margin: 0 5px;
    outline: none !important;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
}

.maplibregl-link-disabled {
    color: #555c66;
}

.maplibregl-link svg {
    margin-right: 5px;
    height: 22px;
}

.maplibregl-link svg[data-testid='ArrowRightIcon'] {
    margin-right: 0px;
}

.maplibregl-link:hover, .maplibregl-link:active {
    background-color: #fbf6f8;
}

.maplibregl-image {
    width: calc(100% + 40px);
    margin-top: -45px;
    margin-left: -20px;
    margin-bottom: 10px;
    height: 150px;
    max-width: unset;
    object-fit: cover;
}

.maplibregl-link-deactivate {
    margin-top: 5px;
    display: flex;
}

.maplibregl-search-container {
    position: absolute;
    top: 30px;
    left: 30px;
    z-index: 2;
    width: 90%;
    max-width: 180px;
    display: flex;
    background-color: white;
    opacity: .9;
    padding: 7px 15px;
    border-radius: 15px;
    box-shadow: 0 2px 5px 0 rgba(0, 4, 8, 0.07);
    transition: all 0.3s;
}

.maplibregl-search-container:focus-within {
    max-width: 220px;
}

.maplibregl-search-loader {
    padding-left: 10px;
}

.maplibregl-search {
    border: 0;
    width: 100%;
    outline: none !important;
    margin-left: 10px;
    margin-right: 10px;
    text-overflow: ellipsis;
}

.maplibregl-cooperative-gesture-screen {
    z-index: 3;
}

.maplibregl-layer-button-occurrence {
    background-color: #ffffff2e;
    color: #ffffff;
    border-radius: 10px;
    font-size: 9px;
    min-width: 15px;
    margin-left: 7px;
    padding: 1px 3px;
    margin-right: 0;
    height: 15px;
    line-height: 13px;
}

.maplibregl-layer-button-title {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
}

@media (min-width: 768px) {
    .maplibregl-legend {
        position: absolute;
        right: 20px;
        top: 20px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/Map/CustomMapLibre.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,0BAA0B;IAC1B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,cAAc;IACd,mBAAmB;IACnB,wBAAwB;IACxB,2CAA2C;IAC3C,oBAAoB;;IAEpB;QACI,eAAe;QACf,2CAA2C;IAC/C;AACJ;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,uBAAuB;IACvB,yDAAyD;IACzD,eAAe;IACf,uBAAuB;IACvB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,sBAAsB;IACtB,6CAA6C;AACjD;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,6CAA6C;AACjD;;AAEA;IACI,yBAAyB;IACzB,4BAA4B;IAC5B,6CAA6C;AACjD;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;;AAEA;;AAEA;IACI,iBAAiB;IACjB,SAAS;IACT,yDAAyD;IACzD,eAAe;IACf,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,yDAAyD;IACzD,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,yDAAyD;IACzD,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,SAAS;IACT,iBAAiB;IACjB,oBAAoB;IACpB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,YAAY;AAChB;;AAEA;;AAEA;;;AAGA;IACI,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,yBAAyB;IACzB,UAAU;IACV,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB;AACJ;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,oBAAoB;IACpB,2CAA2C;IAC3C,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,oBAAoB;IACpB,8BAA8B;AAClC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,uBAAuB;IACvB,0CAA0C;IAC1C,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,SAAS;IACT,oBAAoB;IACpB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,eAAe;IACf,eAAe;IACf,yDAAyD;IACzD,iBAAiB;IACjB,qBAAqB;IACrB,kBAAkB;IAClB,oBAAoB;IACpB,aAAa;IACb,wBAAwB;IACxB,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,wBAAwB;IACxB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,UAAU;IACV,UAAU;IACV,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,2CAA2C;IAC3C,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,SAAS;IACT,WAAW;IACX,wBAAwB;IACxB,iBAAiB;IACjB,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,2BAA2B;IAC3B,cAAc;IACd,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,OAAO;IACP,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI;QACI,kBAAkB;QAClB,WAAW;QACX,SAAS;IACb;AACJ","sourcesContent":["button.maplibregl-popup-close-button {\n    width: 30px;\n    height: 30px;\n    font-size: 30px !important;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin: 15px;\n    color: #222222;\n    border-radius: 15px;\n    outline: none !important;\n    background-color: rgba(255, 255, 255, 0.20);\n    transition: all 0.3s;\n\n    &:hover {\n        font-size: 30px;\n        background-color: rgba(255, 255, 255, 0.40);\n    }\n}\n\n.maplibregl-popup {\n    z-index: 3;\n}\n\n.maplibregl-popup-content {\n    padding: 45px 20px 20px;\n    font-family: \"GTAmerica-Rg\", \"franklingothic-book\", serif;\n    font-size: 15px;\n    background-color: white;\n    color: #222222;\n    min-width: 150px;\n    text-align: center;\n    border-radius: 4px;\n    word-break: break-word;\n    box-shadow: 0 10px 20px 0 rgba(0, 4, 8, 0.07);\n}\n\n.maplibregl-popup-anchor-bottom .maplibregl-popup-tip {\n    border-color: transparent;\n    border-top-color: #ffffff;\n    box-shadow: 0 10px 20px 0 rgba(0, 4, 8, 0.07);\n}\n\n.maplibregl-popup-anchor-top .maplibregl-popup-tip {\n    border-color: transparent;\n    border-bottom-color: #ffffff;\n    box-shadow: 0 10px 20px 0 rgba(0, 4, 8, 0.07);\n}\n\n.maplibregl-ctrl {\n    display: none;\n}\n\n.maplibregl-layer {\n    position: absolute;\n    z-index: 2;\n}\n\n.maplibregl-map {\n\n}\n\n.maplibregl-h3 {\n    padding: 10px 0 0;\n    margin: 0;\n    font-family: \"GTAmerica-Bd\", \"franklingothic-book\", serif;\n    font-size: 17px;\n    letter-spacing: -0.5px;\n    font-weight: normal;\n    line-height: 1.2;\n}\n\n.maplibregl-h4 {\n    margin: 5px 0 -4px;\n    font-family: \"GTAmerica-Bd\", \"franklingothic-book\", serif;\n    font-size: 14px;\n    line-height: 1.11;\n    font-weight: normal;\n    letter-spacing: -0.25px;\n    color: #888888;\n}\n\n.maplibregl-h5 {\n    font-family: \"GTAmerica-Bd\", \"franklingothic-book\", serif;\n    font-size: 13px;\n    line-height: 1.11;\n    font-weight: normal;\n    letter-spacing: -0.25px;\n    color: #888888;\n    margin: 12px 0 0 0;\n}\n\n.maplibregl-label, .maplibregl-layer-button {\n    background-color: #a21236;\n    border-radius: 4px;\n    color: white;\n    font-size: .8em;\n    padding: 2px 10px;\n    font-weight: bold;\n    margin-right: 10px;\n    margin-top: 10px;\n    border: 0;\n    line-height: 20px;\n    transition: all 0.2s;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    max-width: 220px;\n}\n\n.maplibregl-layer-button {\n    cursor: pointer;\n    max-width: 300px;\n}\n\n.maplibregl-layer h5 {\n    text-transform: none;\n}\n\n.maplibregl-layer-button-content {\n    display: flex;\n    align-items: center;\n}\n\n.maplibregl-content {\n    color: #888888;\n    padding: 20px 0 15px;\n}\n\n.maplibregl-container {\n    position: relative;\n    border-radius: 4px;\n    background-color: #ffffff;\n}\n\n.maplibregl-map-container {\n    position: relative;\n    height: 100%;\n}\n\n.maplibregl-map-fullscreen {\n\n}\n\n\n.maplibregl-toggle {\n    position: absolute;\n    bottom: 20px;\n    left: 30px;\n    background-color: #ffffff;\n    z-index: 2;\n    border-radius: 4px;\n    padding: 10px 10px 0;\n    cursor: pointer;\n    overflow: hidden;\n    box-shadow: 0 2px 5px 0 rgba(0, 4, 8, 0.07)\n}\n\n.maplibregl-layer-toggle {\n    bottom: 20px;\n}\n\n.maplibregl-fullscreen-toggle {\n    bottom: 50px;\n}\n\n.maplibregl-layer {\n    margin: 10px;\n    background-color: #ffffff;\n    border-radius: 4px;\n    padding: 0 10px 10px;\n    box-shadow: 0 2px 5px 0 rgba(0, 4, 8, 0.07);\n    position: absolute;\n    bottom: 20px;\n    left: 70px;\n    transition: all 0.3s;\n    max-width: calc(100vw - 140px);\n}\n\n.maplibregl-layer-button-disabled {\n    background-color: #aaaaaa;\n}\n\n.maplibregl-layer-toggle svg, .maplibregl-fullscreen-toggle svg {\n    color: #a31335;\n    transition: all 0.2s;\n}\n\n.maplibregl-layer-toggle-disabled svg, .maplibregl-fullscreen-toggle-disabled svg {\n    color: #aaaaaa;\n}\n\n.maplibregl-legend {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    align-items: flex-start;\n    background-color: rgba(255, 255, 255, 0.9);\n    border-radius: 4px;\n    z-index: 2;\n    right: 20px;\n    top: 20px;\n    padding: 10px 10px 0;\n    margin: 0;\n}\n\n.maplibregl-legend-item {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    margin-bottom: 10px;\n}\n\n.maplibregl-legend-item-style {\n    margin-right: 10px;\n}\n\n.maplibregl-labels {\n    text-align: center;\n    display: flex;\n    flex-wrap: wrap;\n}\n\n.maplibregl-links {\n    margin-top: 0px;\n    margin-bottom: 10px;\n    display: flex;\n    flex-wrap: inherit;\n    flex-direction: column;\n}\n\n.maplibregl-link {\n    color: #a01637;\n    padding: .25rem;\n    font-size: 13px;\n    font-family: \"GTAmerica-Bd\", \"franklingothic-book\", serif;\n    font-weight: bold;\n    text-decoration: none;\n    border-radius: 4px;\n    transition: all 0.3s;\n    margin: 0 5px;\n    outline: none !important;\n    cursor: pointer;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.maplibregl-link-disabled {\n    color: #555c66;\n}\n\n.maplibregl-link svg {\n    margin-right: 5px;\n    height: 22px;\n}\n\n.maplibregl-link svg[data-testid='ArrowRightIcon'] {\n    margin-right: 0px;\n}\n\n.maplibregl-link:hover, .maplibregl-link:active {\n    background-color: #fbf6f8;\n}\n\n.maplibregl-image {\n    width: calc(100% + 40px);\n    margin-top: -45px;\n    margin-left: -20px;\n    margin-bottom: 10px;\n    height: 150px;\n    max-width: unset;\n    object-fit: cover;\n}\n\n.maplibregl-link-deactivate {\n    margin-top: 5px;\n    display: flex;\n}\n\n.maplibregl-search-container {\n    position: absolute;\n    top: 30px;\n    left: 30px;\n    z-index: 2;\n    width: 90%;\n    max-width: 180px;\n    display: flex;\n    background-color: white;\n    opacity: .9;\n    padding: 7px 15px;\n    border-radius: 15px;\n    box-shadow: 0 2px 5px 0 rgba(0, 4, 8, 0.07);\n    transition: all 0.3s;\n}\n\n.maplibregl-search-container:focus-within {\n    max-width: 220px;\n}\n\n.maplibregl-search-loader {\n    padding-left: 10px;\n}\n\n.maplibregl-search {\n    border: 0;\n    width: 100%;\n    outline: none !important;\n    margin-left: 10px;\n    margin-right: 10px;\n    text-overflow: ellipsis;\n}\n\n.maplibregl-cooperative-gesture-screen {\n    z-index: 3;\n}\n\n.maplibregl-layer-button-occurrence {\n    background-color: #ffffff2e;\n    color: #ffffff;\n    border-radius: 10px;\n    font-size: 9px;\n    min-width: 15px;\n    margin-left: 7px;\n    padding: 1px 3px;\n    margin-right: 0;\n    height: 15px;\n    line-height: 13px;\n}\n\n.maplibregl-layer-button-title {\n    flex: 1;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n@media (min-width: 768px) {\n    .maplibregl-legend {\n        position: absolute;\n        right: 20px;\n        top: 20px;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
